import shieldImage from "../../../assets/images/PlanForSchools.png";
import { ReactComponent as ShieldIcon } from "../../../assets/icons/ShieldIcon.svg";
import BlueBgImage from "../../../assets/images/BlueBackground.png";
import { HashLink } from "react-router-hash-link";
import SecondaryButton from "../../designSystem/SecondaryButton";
import { useLocation } from "react-router-dom";

const PlanForSchools = () => {
  const location = useLocation();
  const isSchoolPage = location.pathname === "/for-schools";
  return (
    <section
      // className="plan"
      style={{ backgroundImage: `url(${BlueBgImage})` }}
      className=" plan section-bg section-bg--blue"
    >
      <div className="plan__container">
        {/* LEFT CONTENT */}
        <div className="plan__content">
          <h4>
            PLAN FOR SCHOOLS
            <div className="divider" />
          </h4>
          <div className="content-medium">
            Fee protection advice for your families — at no cost to your school.
          </div>
          <div className="content">
            We work alongside your school to provide families with specialist
            school fee protection ensuring that unforeseen circumstances do not
            interrupt a child’s education.
          </div>

          <ul className="plan__list">
            <div className="row">
              <ShieldIcon />
              <div className="column-gap">
                <li
                  className="body"
                  style={{ marginBottom: "0px", textAlign: "left" }}
                >
                  Fee protection insurance tailored specifically for independent
                  school families
                </li>
                <span
                  className="body-medium accent"
                  style={{ marginBottom: "20px" }}
                >
                  — at no cost to your school
                </span>
              </div>
            </div>
            <div className="row">
              <ShieldIcon />
              <div className="column-gap">
                <li
                  className="body"
                  style={{ marginBottom: "0px", textAlign: "left" }}
                >
                  Helping families maintain continuity of education through
                  life's most difficult events
                </li>
                <span
                  className="body-medium accent"
                  style={{ marginBottom: "20px" }}
                >
                  — your school simply makes the introduction
                </span>
              </div>
            </div>
            <div className="row">
              <ShieldIcon />
              <div className="column-gap">
                <li
                  className="body"
                  style={{ marginBottom: "0px", textAlign: "left" }}
                >
                  Specialist, regulated advice with one purpose: safeguarding
                  the child's place at school
                </li>
                <span
                  className="body-medium accent"
                  style={{ marginBottom: "20px" }}
                >
                  — we manage everything that follows
                </span>
              </div>
            </div>
          </ul>
          <HashLink
            smooth
            to={isSchoolPage ? "/for-schools#contact" : "/#contact"}
            style={{ textDecoration: "none" }}
          >
            <SecondaryButton>
              <div className="button-text primary">SIGN UP NOW</div>
            </SecondaryButton>
          </HashLink>
        </div>

        {/* RIGHT IMAGE */}
        <div className="plan__image-wrap">
          <img src={shieldImage} alt="School planning" />
        </div>
      </div>
    </section>
  );
};

export default PlanForSchools;
